import React, { useState, useEffect } from 'react';
import { Card } from './Card';
import cx from 'classnames';
import { Popover, Button, DescriptionList } from '..';
import { Position } from '@blueprintjs/core';
import { blankIcon, chevronIcon, tickIcon } from './functions/icons';
export const NoOption = () => {
    return React.createElement("div", { className: "card-dropdown_static" });
};
export const LoadingOption = () => {
    return (React.createElement("div", { className: "card-dropdown_static loading" },
        React.createElement("div", { className: "card-dropdown_label--loading" })));
};
// create a static option with icon and description
export const CardDropdownOption = ({ data, selected = false, onClick, loading = false, }) => {
    return loading ? (React.createElement(LoadingOption, null)) : (React.createElement("div", { className: cx('card-dropdown_static', {
            selected: !loading && selected,
        }), onClick: typeof onClick !== 'undefined' ? onClick : undefined },
        React.createElement("div", { className: cx('card-dropdown_icon', `${data.label.toLowerCase()}`, {}) }, data.icon),
        React.createElement("div", { className: "card-dropdown_label" }, data.label),
        React.createElement("div", { className: "card-dropdown_tick" }, !loading && selected && tickIcon)));
};
export const CardDropdown = ({ options, defaultSelectedOption, onInteraction = () => { }, onSelect = () => { }, loading, disabled, translationData = {
    editCauseDropdown: 'Edit cause dropdown',
}, }) => {
    const [selected, updateSelected] = useState(defaultSelectedOption);
    const [isOpen, togglePopup] = useState(false);
    useEffect(() => {
        updateSelected(defaultSelectedOption);
    }, [defaultSelectedOption]);
    const toggleDropdown = () => {
        onInteraction(isOpen);
        togglePopup(!isOpen);
    };
    const closeDropdown = () => {
        togglePopup(false);
    };
    const checkStaticOrDynamic = (key) => key === 'header' || key === 'footer';
    const checkIfSelected = (key, index) => !loading && selected.key === key && selected.index === index;
    const onSelectEvent = (selectedNode) => {
        updateSelected(selectedNode);
        onSelect(selectedNode);
        closeDropdown();
    };
    const displaySelectedOption = ({ key, index }) => {
        if (typeof options[key] === 'undefined' ||
            typeof options[key][index] === 'undefined' ||
            !options[key][index]) {
            return React.createElement(NoOption, null);
        }
        const data = options[key][index];
        const isStatic = checkStaticOrDynamic(key);
        if (isStatic) {
            return React.createElement(CardDropdownOption, { data: data });
        }
        else {
            return React.createElement(DescriptionList, { items: data.items, includeTitle: false, loading: false });
        }
    };
    return (React.createElement(Card, null,
        React.createElement("div", { className: "card-dropdown" },
            React.createElement("div", { className: "card-dropdown_content" },
                React.createElement(Popover, { isOpen: isOpen, onInteraction: bool => {
                        if (!bool) {
                            closeDropdown();
                        }
                    }, usePortal: false, transitionDuration: 0, autoFocus: true, popoverClassName: "card-dropdown_popover", position: Position.BOTTOM },
                    React.createElement(Button, { onClick: !disabled ? toggleDropdown : undefined, className: cx('filter-category-button', {
                            'disabled-dropdown': disabled,
                        }), style: "subtle", rightIcon: !disabled ? chevronIcon : blankIcon, "aria-label": translationData.editCauseDropdown }, displaySelectedOption(selected)),
                    React.createElement("div", { className: "card-dropdown_selection" }, Object.keys(options).map(key => {
                        const isStatic = checkStaticOrDynamic(key);
                        const availableOptions = options[key];
                        const isValid = availableOptions && availableOptions.length;
                        return (React.createElement("div", { key: key, className: cx({
                                'card-dropdown_selection-static': isValid && isStatic,
                                'card-dropdown_selection-dynamic': isValid && !isStatic,
                                'card-dropdown_selection-invalid': !isValid,
                                loading,
                            }) },
                            isStatic &&
                                isValid &&
                                availableOptions.map((option, index) => (React.createElement(CardDropdownOption, { key: `${key}-${index}-row`, selected: checkIfSelected(key, index), data: option, onClick: () => {
                                        onSelectEvent({
                                            key,
                                            index,
                                        });
                                    }, loading: loading }))),
                            !isStatic &&
                                isValid &&
                                availableOptions.map((option, index) => (React.createElement("div", { key: `${key}-${index}-row`, className: cx({
                                        selected: checkIfSelected(key, index),
                                        loading,
                                    }), onClick: () => {
                                        onSelectEvent({
                                            key,
                                            index,
                                        });
                                    } },
                                    React.createElement(DescriptionList, { items: option.items, includeTitle: false, loading: loading }),
                                    checkIfSelected(key, index) && React.createElement("div", { className: "tick" }, tickIcon))))));
                    })))))));
};
//# sourceMappingURL=CardDropdown.js.map